import { SiteAnalyzerElement } from "./site-analyzer";
export type { AnalysisReport, AnalyzerEventName, Finding } from "./types";

if (!customElements.get("site-analyzer"))
  customElements.define("site-analyzer", SiteAnalyzerElement);
